import { cx } from '@mage-ui/styled-system/css';
import { section } from '@mage-ui/styled-system/recipes';
import { SectionHeading } from './section-headings/SectionHeading';

export const Section = ({ heading, children, footer, className, ...props }) => {
  return (
    <section className={cx(section().root, className)} {...props}>
      <SectionHeading data={heading} />
      {children}
      {footer && (
        <div className={className?.footer ?? section().footer}>{footer}</div>
      )}
    </section>
  );
};
